/**
 * 订单 / 物流 V2 灰度白名单。
 *
 * 值来自组织配置 whiteListConfig.TRADE_API_V2_ENABLE，登录后由 useSetup 写入内存。
 * 命中时走 V2 接口，未命中或配置未加载时走 V1。
 */
let tradeApiV2Enabled = false;

export function setTradeApiV2Enabled(enabled?: boolean) {
  tradeApiV2Enabled = Boolean(enabled);
}

export function isTradeApiV2Enabled(): boolean {
  return tradeApiV2Enabled;
}
